import { render, staticRenderFns } from "./FieldsetCompanyGeneral.yaml?vue&type=template&id=58d398e2&component"
import script from "./FieldsetCompanyGeneral.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetCompanyGeneral.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports